// Components
import SyncCalendarStep from './steps/SyncCalendarStep';
import GiveKudosStep from './steps/GiveKudosStep';
import AddIntegrationsStep from './steps/AddIntegrationsStep';
import SetupGroupWorkspaceStep from './steps/SetupGroupWorkspaceStep';
import UpdateYourProfileStep from './steps/UpdateYourProfileStep';
import DismissStep from './steps/DismissStep';

export enum QuickStartGuideItemIDs {
  addDiscussionTopics = 'add-discussion-topics',
  syncCalendar = 'sync-calendar',
  giveKudos = 'give-kudos',
  addIntegrations = 'add-integrations',
  setupGroupWorkspace = 'setup-group-workspace',
  updateYourProfile = 'update-your-profile',
  dismiss = 'dismiss',
}
export const QuickStartGuideItems = [
  {
    id: QuickStartGuideItemIDs.syncCalendar,
    titleKey: 'perform.onboarding.qsg.list.sync_calendar.title',
    descriptionKey: 'perform.onboarding.qsg.list.sync_calendar.description',
    icon: '📆',
    component: SyncCalendarStep,
  },
  {
    id: QuickStartGuideItemIDs.giveKudos,
    titleKey: 'perform.onboarding.qsg.list.give_kudos.title',
    descriptionKey: 'perform.onboarding.qsg.list.give_kudos.description',
    icon: '🌈',
    component: GiveKudosStep,
  },
  {
    id: QuickStartGuideItemIDs.addIntegrations,
    titleKey: 'perform.onboarding.qsg.list.add_integrations.title',
    descriptionKey: 'perform.onboarding.qsg.list.add_integrations.description',
    icon: '🔌',
    component: AddIntegrationsStep,
  },
  {
    id: QuickStartGuideItemIDs.setupGroupWorkspace,
    titleKey: 'perform.onboarding.qsg.list.setup_group_workspace.title',
    descriptionKey: 'perform.onboarding.qsg.list.setup_group_workspace.description',
    icon: '🙌',
    component: SetupGroupWorkspaceStep,
  },
  {
    id: QuickStartGuideItemIDs.updateYourProfile,
    titleKey: 'perform.onboarding.qsg.list.update_profile.title',
    descriptionKey: 'perform.onboarding.qsg.list.update_profile.description',
    icon: '😉',
    component: UpdateYourProfileStep,
  },
  {
    id: QuickStartGuideItemIDs.dismiss,
    titleKey: 'perform.onboarding.qsg.list.dismiss.title',
    descriptionKey: 'perform.onboarding.qsg.list.dismiss.description',
    button: true,
    component: DismissStep,
  },
];
